import { supabase } from "@/integrations/supabase/client";

export interface RegenerateResult {
  file_path?: string;
  file_size?: number;
  already_present?: boolean;
  not_regenerable?: boolean;
  error?: string;
}

/**
 * Ask the regenerate-document-pdf edge function to render + upload a PDF
 * for a finalized generated_documents row that has no file yet.
 * Idempotent: the function short-circuits if a file_path already exists.
 */
export async function regenerateDocumentPdf(
  documentId: string,
): Promise<RegenerateResult> {
  const { data, error } = await supabase.functions.invoke(
    "regenerate-document-pdf",
    { body: { documentId } },
  );
  if (error) {
    // Edge function returned non-2xx; try to surface the JSON payload.
    let msg = error.message || "Failed to prepare PDF";
    try {
      const ctx: any = (error as any).context;
      if (ctx && typeof ctx.json === "function") {
        const j = await ctx.json();
        if (j?.error) msg = j.error;
      }
    } catch { /* ignore */ }
    return { error: msg };
  }
  return (data ?? {}) as RegenerateResult;
}
